import React from 'react';
import { motion } from 'framer-motion';

export default function WhyReachOut() {
  return (
    <section className="py-28 px-6 md:px-12 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-24 items-center">
          
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9 }}
          >
            <p className="text-brand-gold text-sm uppercase tracking-[0.3em] font-bold mb-5">Context</p>
            <h2 className="text-4xl md:text-5xl font-serif text-brand-dark mb-10 leading-tight">
              People Usually <br />
              <span className="italic text-brand-gold">Reach Out When...</span>
            </h2>
            
            <ul className="space-y-6">
              {[
                'A business decision feels unusually heavy',
                'Expansion or investment timing feels uncertain',
                'Partnerships need deeper evaluation before commitment',
                'Personal decisions are affecting professional focus',
                'Important transitions are approaching'
              ].map((reason, i) => (
                <motion.li 
                  key={i}
                  initial={{ opacity: 0, x: -10 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.1, duration: 0.6 }}
                  className="flex items-start gap-5"
                >
                  <span className="mt-2.5 w-2 h-2 rounded-full bg-brand-gold flex-shrink-0"></span>
                  <span className="text-stone-700 font-medium leading-relaxed text-xl">{reason}</span>
                </motion.li>
              ))}
            </ul>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2, duration: 0.9 }}
            className="space-y-10 bg-brand-accent p-10 md:p-14 rounded-sm border border-brand-gold/20 shadow-md"
          >
            <div className="w-12 h-1 bg-brand-gold mb-2"></div>
            <p className="font-serif text-3xl md:text-4xl text-brand-dark leading-relaxed">
              Most people don't come because they lack intelligence.
            </p>
            <p className="text-stone-700 font-medium leading-relaxed text-2xl">
              They come because clarity becomes difficult under pressure.
            </p>
            
            <div className="pt-6 border-t border-brand-gold/30">
              <p className="text-stone-600 text-lg font-medium italic leading-relaxed">
                Vedic Astrology and Vastu Shastra offer a different lens. Not a replacement for judgment. A complement to it.
              </p>
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
}